import {
  Box,
  Button,
  ButtonDropdown,
  ButtonDropdownProps,
  Modal,
  SpaceBetween,
} from '@amzn/awsui-components-core';
import React from 'react';
import constants from '../../common/constants';
import ButtonDropdownItem from '../../model/ButtonDropdownItem';
import ButtonDropdownSection from '../../model/ButtonDropdownSection';

interface ModalDialogButtonProps {
  items: ButtonDropdownSection[];
  buttonText?: string;
  disabled?: boolean;
  inputValid?: boolean;
}

interface ModalDialogButtonState {
  selectedItem?: ButtonDropdownItem;
  isModalOpen: boolean;
  isOpeningModal: boolean;
  isSubmitting: boolean;
  inputValid: boolean;
}

class ModalDialogDropdownButton extends React.Component<
  ModalDialogButtonProps,
  ModalDialogButtonState
> {
  static defaultProps = {
    disabled: false,
    loading: false,
  };

  constructor(props: ModalDialogButtonProps) {
    super(props);

    this.state = {
      isModalOpen: false,
      isOpeningModal: false,
      isSubmitting: false,
      // @ts-expect-error TS2322 - strict migration
      inputValid: props.inputValid,
    };
  }

  public componentDidUpdate(prevProps: ModalDialogButtonProps) {
    if (this.props.inputValid !== prevProps.inputValid) {
      this.setState({
        // @ts-expect-error TS2322 - strict migration
        inputValid: this.props.inputValid,
      });
    }
  }

  public render() {
    const { buttonText, items, disabled, inputValid } = this.props;
    const { isModalOpen, isSubmitting, selectedItem, isOpeningModal } = this.state;

    const actionButtons = (
      <Box float="right">
        <SpaceBetween direction="horizontal" size="xs">
          <Button variant="normal" onClick={this.cancelModal}>
            {constants.CANCEL_BUTTON_TEXT}
          </Button>
          <Button
            variant="primary"
            onClick={this.submit}
            loading={isSubmitting}
            disabled={inputValid === undefined ? !!selectedItem?.requiresInput : !inputValid}
          >
            {selectedItem?.submitButtonText || 'Submit'}
          </Button>
        </SpaceBetween>
      </Box>
    );

    // @ts-expect-error TS2722 - strict migration
    const modalContent = <div>{selectedItem?.inputForm()}</div>;

    const dropdownItemGroups: ButtonDropdownProps.ItemGroup[] = items
      .filter((i) => i.items.length > 0)
      .map((i) => ({ id: i.id, text: i.text, disabled: i.disabled, items: i.items }));

    const modal = selectedItem ? (
      <Modal
        key={selectedItem?.id}
        header={selectedItem?.header}
        size={selectedItem?.modalSize ? selectedItem?.modalSize : 'large'}
        visible={isModalOpen}
        onDismiss={this.cancelModal}
        footer={actionButtons}
        closeAriaLabel="Close modal"
      >
        {modalContent}
      </Modal>
    ) : null;

    return (
      <Box display="inline-block">
        {modal}
        <ButtonDropdown
          className="inner-buttons"
          items={dropdownItemGroups}
          onItemClick={this.openModal}
          disabled={disabled}
          loading={isOpeningModal}
        >
          {buttonText}
        </ButtonDropdown>
      </Box>
    );
  }

  private submit = async () => {
    this.setState({
      isSubmitting: true,
    });

    try {
      // @ts-expect-error TS2339 - strict migration
      const { onSubmit, id } = this.state.selectedItem;
      if (onSubmit) {
        await onSubmit(id);
      }
    } finally {
      this.setState({
        isSubmitting: false,
      });
      this.closeModal();
    }
  };

  private openModal = async (event: any) => {
    this.setState({
      isOpeningModal: true,
    });

    const { items } = this.props;
    let foundSubItem: ButtonDropdownItem;
    for (const item of items) {
      let found = item.items.find((i) => i.id === event.detail.id);
      if (found) {
        foundSubItem = found;
        break;
      }
      item.items.forEach((i) => {
        if (Array.isArray(i?.items)) {
          found = i.items.find((subItem) => subItem.id === event.detail.id);
          if (found) {
            foundSubItem = found;
          }
        }
      });
    }
    // @ts-expect-error TS2454 - strict migration
    if (foundSubItem) {
      const { onBeforeOpenModal } = foundSubItem;
      if (!onBeforeOpenModal || (await onBeforeOpenModal())) {
        this.setState({
          isModalOpen: true,
          selectedItem: foundSubItem,
        });
      }
    }

    this.setState({
      isOpeningModal: false,
    });
  };

  private closeModal = () => {
    this.setState({
      isModalOpen: false,
      selectedItem: undefined,
    });
  };

  // Runs the item's onCancel only for an explicit cancel or dismiss, never after a submit.
  private cancelModal = () => {
    const { selectedItem } = this.state;
    this.closeModal();
    selectedItem?.onCancel?.();
  };
}

export default ModalDialogDropdownButton;
